module.exports = __webpack_public_path__ + "img/24.8d2738cc.jpg";